module.exports = {
    host:"https://flaskapi.dent.lingosoft.co",
    socketio_host:"https://socketio.dent.lingosoft.co",
    mobile_backend_host:"https://mobileapi.dent.lingosoft.co"
}